import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { DicomHeadersModalWrapper } from "@src/modules/DicomViewer/DicomHeadersModal/DicomHeadersModal.components";
import HeadersTable from "@src/modules/DicomViewer/DicomHeadersModal/DicomHeadersTable";
import useDicomHeaders from "@src/modules/DicomViewer/DicomHeadersModal/hooks/useDicomHeaders";
import Button from "@src/modules/shared/components/Button";
import { BaseModalWrapperProps } from "@src/modules/shared/components/Modal/BaseModalWrapper";
import { ModalButtonsWrapper } from "@src/modules/shared/components/Modal/ModalButtonsWrapper";
import { ModalContent } from "@src/modules/shared/components/Modal/ModalContent";
import ModalHeader from "@src/modules/shared/components/Modal/ModalHeader";
import useModal from "@src/modules/shared/components/Modal/useModal";

interface Props extends BaseModalWrapperProps {
  s3Url: string;
}

const DicomHeadersModal: FunctionComponent<Props> = ({
  s3Url,
  ...modalProps
}) => {
  const { t } = useTranslation();
  const { closeModal } = useModal();
  const { data } = useDicomHeaders(s3Url);

  return (
    <DicomHeadersModalWrapper {...modalProps}>
      <ModalHeader>{t("Dicom headers")}</ModalHeader>
      <ModalContent>
        {data && <HeadersTable headers={data} />}
        <ModalButtonsWrapper>
          <Button buttonType="primary" onClick={closeModal}>
            {t("Close")}
          </Button>
        </ModalButtonsWrapper>
      </ModalContent>
    </DicomHeadersModalWrapper>
  );
};

export default DicomHeadersModal;
